import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: 'tfb-am-root-component',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.scss']
})
export class RootComponent implements OnInit {
  constructor(
    private _router: Router
  ) {
  }

  ngOnInit(): void {
    this._router.navigate(["apps", "tfb_acctmgmt", "account-management", "home"], {replaceUrl: true});
  }
}
